/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number6Dark = () => (
	<>
		<circle cx="16" cy="16" r="16" fill="#002855" />
		<path
			d="M16.4475 25.4275C12.15 25.4275 9.375 22.36 9.375 17.6125C9.375 11.89 13.68 7.7725 20.0925 7.375C20.1 7.375 20.1075 7.375 20.115 7.375C20.2425 7.375 20.3625 7.435 20.43 7.5475L20.835 8.17C20.9025 8.275 20.9175 8.4025 20.865 8.515C20.8125 8.6275 20.715 8.71 20.595 8.74C17.2425 9.46 15.24 11.32 14.505 14.425C15.27 13.99 16.3875 13.57 17.8275 13.57C20.9625 13.57 23.0775 15.7375 23.0775 18.9625C23.0775 22.7725 20.3475 25.435 16.44 25.435L16.4475 25.4275ZM14.235 16.2025C14.205 16.645 14.1825 17.1025 14.1825 17.5675C14.1825 21.3625 15.135 23.7175 16.665 23.7175C18.525 23.7175 18.6675 21.0325 18.6675 20.2075C18.6675 18.1525 17.865 15.9475 15.6075 15.9475C15.1575 15.9475 14.715 16.03 14.235 16.2025Z"
			fill="white"
		/>
	</>
);

export default Number6Dark;
